import React, {Fragment} from 'react';

export function SpeciesTableDeltaColumn(props) {
    const {modifiedId, nonModifiedId, modifiedValue, nonModifiedValue, insteadOfLabel, iconComponent } = props?.Value ?? {};

    const isModified = (modifiedId ?? nonModifiedId ?? '') !== (nonModifiedId ?? '') || (modifiedValue ?? nonModifiedValue ?? '') !== (nonModifiedValue ?? '');

    return <Fragment>
        { iconComponent }
        {
            isModified ?
                <Fragment>
                    {modifiedValue}
                    <div className="sb-sub-text">
                        {insteadOfLabel != null ? insteadOfLabel : "Instead of: "}{nonModifiedValue}
                    </div>
                </Fragment>
                :
                nonModifiedValue
        }
    </Fragment>;
}


